/**
 * inputEmailDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

export function inputEmailDirective() {
    return {
        template: `
            <md-input-container>
                <label>{{ label }}</label>
                
                <input type="email"
                       name="{{ name || '' }}"
                       ng-model="value"
                       ng-change="_onValueChanged()"
                       ng-disabled="disabled"
                       ng-readonly="readonly"
                       ng-required="required">

                <div class="hint" ng-show="hint" ng-if="!form[name].$invalid">
                    {{ hint }}
                </div>

                <div ng-if="form && name" ng-messages="form[name].$error">
                    <div ng-message="required">Required</div>
                    <div ng-repeat="(key, message) in errorMessages" ng-message="{{ key }}">{{ message }}</div>
                </div>
            </md-input-container>
        `,
        scope: {
            readonly: '=ngReadonly',
            disabled: '=ngDisabled',
            errorMessages: '=errorMessages',
            form: '=form',
            hint: '@?hint',
            label: '@label',
            name: '@name',
            placeholder: '@?placeholder',
            required: '=?required',
            onChange: '&?change',
            value: '=value',
        },
        link: function(scope, element, attrs) {
            element.addClass('app-form-field');

            const $inputContainer = element.find('md-input-container');
            const $input = $inputContainer.find('input')[0];

            scope._onValueChanged = _onValueChanged;

            // If it's undefined on the scope, it may mean that the attribute is there but
            // without content. If the attribute isn't undefined then we know it's been added.
            if (scope.required === undefined && attrs.required !== undefined) {
                scope.required = true;
            }

            scope.$watch('placeholder', placeholder => {
                if (placeholder) {
                    $input.placeholder = placeholder;
                    $inputContainer.addClass('md-input-has-placeholder');
                } else {
                    $input.placeholder = '';
                    $inputContainer.removeClass('md-input-has-placeholder');
                }
            });

            function _onValueChanged() {
                if (angular.isFunction(scope.onChange)) {
                    scope.onChange();
                }

                if (!scope.form || !scope.name) {
                    return;
                }

                if (scope.value && scope.form && scope.form[scope.name]) {
                    scope.form[scope.name].$setValidity('custom', true);
                    scope.form[scope.name].customError = null;
                }
            }
        },
    };
}
